import { EStepCode, TFormStoreData, TStep } from '../../../types/form';

export interface IGetQuizMaxHeightParams {
  formData: TFormStoreData;
  currentStep: TStep;
}

/** Условие конца дерева вопросов */
const isLastStep = <T extends string[]>(children: T): boolean => children[0] === 'formSent';

/** Получает объект шага из опросника по переданному коду шага */
const getQuizStepByStepCode = (formData: TFormStoreData, stepCode: EStepCode): TStep =>
  formData.schema.steps.find(step => step.code === stepCode) as TStep;

/**
 * Хелпер возвращает высоту поддерева опросника - длину самой длинной ветви
 * Если передать не начало опросника - прошедшие шаги учтены не будут.
 * */
export const getQuizMaxHeight = (params: IGetQuizMaxHeightParams): number => {
  const {
    currentStep: { nextStep },
    formData,
  } = params;

  /** Набор уникальных "листьев" для текущего шага */
  const _children = nextStep.reduce((acc, obj) => {
    acc.add(obj.nextStepCode);

    return acc;
  }, new Set() as Set<EStepCode>);
  const children = Array.from(_children);

  /** Высота последнего шага в дереве равна 1 - условие окончания рекурсии */
  if (isLastStep(children)) {
    return 1;
  }

  /** Высота поддерева от текущего шага и вглубь */
  const stepHeight = children.reduce((acc, child) => {
    const currentStep = getQuizStepByStepCode(formData, child);

    const subtreeHeight = getQuizMaxHeight({ currentStep, formData });

    return Math.max(acc, subtreeHeight);
  }, 0);

  return stepHeight + 1;
};
